import request from '@/utils/request'

export function getDocumentById(id) {
  return request({
    url: 'document/getDocumentById/' + id,
    method: 'get'
  });
}

export function createVoucher(data) {
  return request({
    url: 'document/createVoucher',
    method: 'post',
    data
  });
}

export function dowloadDocuments(dateRange, payments) {
  return request({
    url: 'document/dowloadDocuments',
    method: 'post',
    data: {
      date: dateRange,
      payments: payments,
    },
    responseType: 'blob'
  });
}

export function generateConsecutives() {
  return request({
    url: 'document/generateConsecutives',
    method: 'put'
  });
}

export function getCountDocumentsDailyUpload() {
  return request({
    url: 'document/getCountDocumentsDailyUpload',
    method: 'get'
  });
}

export function activateConsecutiveAutomatic(data) {
  return request({
    url: 'document/activateConsecutiveAutomatic',
    method: 'post',
    data
  });
}

export function createComputer() {
  return request({
    url: 'document/createComputer',
    method: 'post'
  });
}

export function createTotals(month) {
  return request({
    url: 'document/createTotals',
    method: 'post',
    data: {
      'month': month
    }
  });
}

export function dowloadZoneReport(data) {
  return request({
    url: 'document/dowloadZoneReport',
    method: 'post',
    data,
    responseType: 'blob'
  });
}

export function deleteDocumentDailyUpload(data) {
  return request({
    url: 'document/deleteDocumentDailyUpload',
    method: 'post',
    data,
  });
}

export function countDocumentDailyUpload() {
  return request({
    url: 'document/countDocumentDailyUpload',
    method: 'get'
  });
}

export function getDocumentDailyUploadLog() {
  return request({
    url: 'document/getDocumentDailyUploadLog',
    method: 'get'
  });
}

export function documentDailyUploadLog(data) {
  return request({
    url: 'document/documentDailyUploadLog',
    method: 'post',
    data
  });
}

export function deleteDocument(id) {
  return request({
    url: 'document/deleteDocument',
    method: 'delete',
    data: {id: id}
  });
}